function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.string.small.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
export var inputField = function inputField(hasValidation, clear, hasError, _ref) {
  var disabled = _ref.disabled,
      small = _ref.small,
      leftIcon = _ref.leftIcon;
  return function (theme) {
    var _leftIcon$size;

    return [_objectSpread(_objectSpread({
      color: theme.gray700,
      border: "1px solid ".concat(hasError ? theme.error : theme.gray200),
      backgroundColor: hasError ? theme.errorLight : theme.white,
      borderRadius: 0,
      minHeight: small ? '3.6rem' : '4.4rem',
      padding: small ? '0.35em 0.85em' : '0.7em 0.85em'
    }, clear && {
      paddingRight: '2em'
    }), {}, {
      width: '100%',
      marginBottom: hasValidation ? 6 : 0,
      outline: 'none'
    }), hasError && {
      '&::placeholder': {
        color: theme.gray500
      }
    }, leftIcon && {
      paddingLeft: "".concat(((_leftIcon$size = leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.size) !== null && _leftIcon$size !== void 0 ? _leftIcon$size : 2) + 0.6, "em")
    }, disabled ? {
      borderColor: theme.gray150,
      color: theme.gray150,
      cursor: 'not-allowed',
      '&::placeholder': {
        color: theme.gray150
      }
    } : {
      '&:focus': {
        borderColor: theme.highlight,
        outline: 'none',
        '&::placeholder': {
          color: theme.gray500
        }
      }
    }];
  };
};
export var inputDeleteIcon = function inputDeleteIcon(label, small) {
  return {
    position: 'absolute',
    right: 8,
    top: "".concat(label ? 3.25 : 1.25 - (small ? 0.45 : 0), "rem")
  };
};